import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Spin} from 'antd'
import FilesList from './FilesList'
import NoFile from './NoFile'

class OriginalFilesTable extends Component {
    _renderTableContent = () => {
        const {originalFiles, onFetchFiles, onChange} = this.props
        
        if (originalFiles.length === 0) {
            return <NoFile/>
        }

        return <FilesList originalFiles={originalFiles} onFetchFiles={onFetchFiles} onChange={onChange}/>
    }

    render() {
        const tableContent = this._renderTableContent()
        const {loading} = this.props

        return (
            <div className='OriginalFilesTable'>
                <Spin spinning={loading} tip='Loading...'>
                    <table className='table table-borderless table-striped'>
                        <thead className='thead-light'>
                        <tr>
                            <th className='Barcode'>Barcode item</th>
                            <th className='PrintColorMode'>Hệ màu file in</th>
                            <th className='PrintingMachineType'>Loại máy in</th>
                            <th className='CreatedDate'>Thời gian lưu</th>
                            <th>Thao tác</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tableContent}
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

OriginalFilesTable.propTypes = {
    originalFiles: PropTypes.array.isRequired,
    onFetchFiles: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
}

export default OriginalFilesTable
